import React, {useRef, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import styles from './styles.module.scss';

const IconWithTooltip = ({
                           icon,
                           children,
                           place,
                           effect,
                           customIconClassName,
                           customTooltipClassName,
                         }) => {
  const [open, setOpen] = useState(false);
  const iconRef = useRef();
  const handleToggleTooltip = e => {
    e.preventDefault();
    e.stopPropagation();

    if (iconRef.current) {
      if (open) {
        ReactTooltip.hide(iconRef.current);
        setOpen(false);
      } else {
        ReactTooltip.show(iconRef.current);
        setOpen(true);
      }
    }
  };

  const listenForOutsideClicks = (ref) => {
    return () => {
      if (Boolean(ref.current)) {
        [`click`, `touchstart`].forEach((type) => {
          document.addEventListener(`click`, (evt) => {
            if (ref.current && ref.current.contains(evt.target)) return;
            ReactTooltip.hide(ref.current);
            setOpen(false);
          });
        });
      }
    };
  };

  useEffect(listenForOutsideClicks(iconRef));

  return (
    <div className={styles.tooltipWrapper}>
      <img
        ref={iconRef}
        src={icon}
        alt="tooltipIcon"
        className={classnames(styles.icon, customIconClassName)}
        data-tip={true}
      />
      <div
        className={styles.actionTriggerScreen}
        onClick={handleToggleTooltip}
      />
      <ReactTooltip
        place={place}
        effect={effect}
        className={classnames(styles.tooltip, customTooltipClassName)}
      >
        {children}
      </ReactTooltip>
    </div>
  );
};

IconWithTooltip.propTypes = {
  icon: PropTypes.string,
  place: PropTypes.string,
  effect: PropTypes.string,
  customIconClassName: PropTypes.string,
  customTooltipClassName: PropTypes.string,
};

export default IconWithTooltip;
